// extracted by mini-css-extract-plugin
export default {"section":"Pregnancy_section__h-AUT","container":"Pregnancy_container__ifJW4","container__photo":"Pregnancy_container__photo__eWOjk","photo":"Pregnancy_photo__n8SlC"};